// extracted by mini-css-extract-plugin
module.exports = {"player":"audioPanel_player__25gZm"};